import {
  SecurityInventoryItem,
  Asset,
  Device,
  Overlay,
} from '@x-guard/xgac-types/xgac';
import { LatLngBoundsExpression, LatLngExpression } from 'leaflet';

export const securityItemsResource = 'security-inventory-items';
export const securityInventoryCategoriesResource = 'security-inventory-categories';
export const appUsersResource = 'app-users';

export const hasItemPosition = (item: SecurityInventoryItem) => Boolean(
  item.location.coordinates && item.location.coordinates.length >= 2,
);

export const itemToLatLng = (item: SecurityInventoryItem): LatLngExpression => [
  item.location.coordinates[1],
  item.location.coordinates[0],
];

export type InventoryItemFilter = {
  categories: string[];
  users: string[];
};

export const NETHERLANDS_CENTER: LatLngExpression = [52.1009166, 5.6462914];
export const DEFAULT_ZOOM = 17;

export const hasButtonPosition = (button: Asset & { device: Device }) => Boolean(
  button.position?.coordinates && button.position.coordinates.length >= 2,
);

export const buttonToLatLng = (button: Asset & { device: Device }): LatLngExpression => [
  button.position?.coordinates[1] ?? 0,
  button.position?.coordinates[0] ?? 0,
];

export const getButtonFloor = (button: Asset & { device: Device }) => button.position?.properties?.address?.floor ?? 0;

export const overlayToLatLngs = (overlay: Overlay): LatLngExpression[] => [
  overlay.points.nw, overlay.points.ne, overlay.points.sw, overlay.points.se].map((p) => [p.lat, p.lng]);

export type MapBoundsCoords = LatLngExpression[] | null | undefined;

export const fitMapToCoords = (map: L.Map, coords: MapBoundsCoords) => {

  if (coords === undefined) return;

  if (coords?.length) {

    map.fitBounds(coords as LatLngBoundsExpression, { maxZoom: 19 });

  } else {

    map.setView(NETHERLANDS_CENTER, DEFAULT_ZOOM);

  }

};
